import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-quotationsheet',
  templateUrl: './quotationsheet.component.html',
  styleUrls: ['./quotationsheet.component.less']
})
export class QuotationsheetComponent implements OnInit {

  @Input() code = 0;
  @Input() pno: any;
  @Input() qsid: any;
  providers = [];
  validateForm: FormGroup;
  uploadFileList: any[] = [];
  filePathList: any[] = [];
  fileType = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp', 'img'];
  status = [
    {id: 0, name: '未成交'},
    {id: 1, name: '跟进中'},
    {id: 2, name: '已丢单'},
    {id: 3, name: '已下单'},
    {id: 4, name: '已付定金'},
    {id: 5, name: '已到款'},
    {id: 6, name: '已开票'},
    {id: 7, name: '已发货'},
    {id: 8, name: '已到货'},
    {id: 9, name: '已退货'},
    {id: 10, name: '已成交'}];
  constructor(
    private customValidatorService: CustomValidatorService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    this.validateForm = this.fb.group({
      qsName: [null, [Validators.required]], // 报价单名称
      qsNo: [null, [Validators.required]], // 报价单编号
      pno: [this.pno, [Validators.required]], // 供应商编号
      qsDesc: [null], // 报价单描述
      qsDate: [null], // 报价单描述
      mark: [null], // 报价单描述
      status: [null], // 报价单状态
      qsMoney: [null], // 报价单金额
      qsBidder: [null], // 报价人
      guaranteePeriod: [null] // 质保期(月)
    });
    if (this.code === 1 || this.code === 2){
      this.providerService.getQuotationSheet(this.qsid).subscribe((data: any) => {
        if ( !this.isEmpty(data) ){
          this.setValidateForm(data);
          const fList = [];
          if (!this.isEmpty(data.filePaths)){
            data.filePaths.forEach(element => {
              let fileNode = new FileNode();
              fileNode = {
                uid: element.id,
                name: element.name,
                url:  element.url,
                status: 'done',
                showDownload: false,
                type: element.type,
                response: { code: 200, data: { url: element.url } },
                iconType: '',
                isImageUrl: false,
                isUploading: false,
                linkProps: undefined,
                message: ''
              };
              fList.push(fileNode);
            });
          }
          this.uploadFileList = fList;
          if (this.code === 2){
            this.validateForm.disable();
          }
        }
      });
    }
    this.providers = await this.providerService.getProviderList();
  }
  getQsForm(){
    return this.validateForm;
  }
  getFilePathList(){
    this.filePathList = [];
    if (this.uploadFileList.length > 0) {
      this.uploadFileList.forEach(element => {
        if (element.response.code === 200) {
          if (this.fileType.some(e => e === element.type)) {
            element.type = 'img';
          } else {
            element.type = 'txt';
          }
          const node = {
            name: element.name,
            url: element.response.data.url,
            type: element.type
          };
          this.filePathList.push(node);
        }
      });
    } else {
      this.filePathList = [];
    }
    return this.filePathList;
  }
  async  handleChange({ file, fileList }: NzUploadChangeParam) {
    if (file.status === 'uploading') {
      return;
    }
    let fList = fileList;
    fList = fList.map(fe => {
      if (fe.response.code === 200) {
        // Component will show file.url as link
        fe.url = 'attachmentServer' + fe.response.data.url;
      }
      return fe;
    });
    this.uploadFileList = fList;
    console.log(this.uploadFileList);
  }

  removeFile = (file: NzUploadFile) => {
    if (this.code === 2) {
      return false;
    } else {
      return true;
    }
  }
  setValidateForm(quotationSheet: any){
    this.validateForm.get('qsName').setValue(!this.isEmpty(quotationSheet.qsName) ? quotationSheet.qsName : null);
    this.validateForm.get('qsNo').setValue(!this.isEmpty(quotationSheet.qsNo) ? quotationSheet.qsNo : null);
    this.validateForm.get('qsMoney').setValue(!this.isEmpty(quotationSheet.qsMoney) ? quotationSheet.qsMoney : null);
    this.validateForm.get('pno').setValue(!this.isEmpty(quotationSheet.pno) ? quotationSheet.pno : null);
    this.validateForm.get('qsDesc').setValue(!this.isEmpty(quotationSheet.qsDesc) ? quotationSheet.qsDesc : null);
    this.validateForm.get('mark').setValue(!this.isEmpty(quotationSheet.mark) ? quotationSheet.mark : null);
    this.validateForm.get('qsDate').setValue(!this.isEmpty(quotationSheet.qsDate) ? quotationSheet.qsDate : null);
    this.validateForm.get('status').setValue(!this.isEmpty(quotationSheet.status) ? Number(quotationSheet.status) : null);
    this.validateForm.get('qsBidder').setValue(!this.isEmpty(quotationSheet.qsBidder) ? quotationSheet.qsBidder : null);
    this.validateForm.get('guaranteePeriod').setValue(
        !this.isEmpty(quotationSheet.guaranteePeriod) ? quotationSheet.guaranteePeriod : null
      );

  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
class FileNode implements NzUploadFile {
  uid: string;
  name: string;
  [key: string]: any;
}
